// ============================================================
// DataGrid — declarative table.
//
// Props:
//   columns: Array<{
//     id: string;
//     header: string;
//     align?: 'left' | 'right' | 'center';
//     width?: number | string;
//     mono?: boolean;
//     render?: (row, index) => ReactNode;  // optional cell renderer
//   }>
//   rows:    Array<Record<string, unknown>>
//   getRowId?: (row, index) => string      // defaults to row.id ?? index
//   onRowClick?: (row, index) => void
//   emptyMessage?: string
// ============================================================

import Table, { THead, TBody, TR, TH, TD } from './Table'
import EmptyState from '../primitives/EmptyState'

export default function DataGrid({
  columns = [],
  rows = [],
  getRowId,
  onRowClick,
  activeRowId,
  emptyMessage = 'No rows.',
}) {
  if (rows.length === 0) {
    return <EmptyState message={emptyMessage} />
  }

  return (
    <Table>
      <THead>
        <TR>
          {columns.map((col) => (
            <TH key={col.id} align={col.align} width={col.width}>
              {col.header}
            </TH>
          ))}
        </TR>
      </THead>
      <TBody>
        {rows.map((row, index) => {
          const id = getRowId ? getRowId(row, index) : (row.id ?? index)
          return (
            <TR
              key={id}
              onClick={onRowClick ? () => onRowClick(row, index) : undefined}
              active={activeRowId !== undefined && id === activeRowId}
              tabStop={index === 0}
            >
              {columns.map((col) => (
                <TD key={col.id} align={col.align} mono={col.mono}>
                  {col.render ? col.render(row, index) : row[col.id]}
                </TD>
              ))}
            </TR>
          )
        })}
      </TBody>
    </Table>
  )
}
